export const COVER_LEVEL_OPTIONS = [{
  value: 'local',
  trackerValue: 'local',
  text: 'Local',
},
{
  value: 'nationwide',
  trackerValue: 'nationwide',
  text: 'Nationwide',
},
{
  value: 'european',
  trackerValue: 'european',
  text: 'European',
}];

export const VEHICLE_TYPES = {
  C: 'Car',
  V: 'Van',
  B: 'Scooter / Motorcycle',
};

export const INSURER_MIN_AGE = 17;

export const ROADSIDE_ASSISTANCE = {
  value: 'roadsideAssistance',
  trackerValue: 'roadsideAssistance',
  label: 'Roadside Assistance',
};

export const OPTIONAL_EXTRAS_OPTIONS = [
  {
    value: 'homeStart',
    trackerValue: 'homeStart',
    label: 'Home start',
  },
  {
    value: 'altTravel',
    trackerValue: 'altTravel',
    label: 'Onward travel',
  },
  {
    value: 'reliefDriver',
    trackerValue: 'reliefDriver',
    label: 'Relief driver',
  },
  {
    value: 'hotel',
    trackerValue: 'hotel',
    label: 'Overnight accommodation',
  },
  {
    value: 'carHire',
    trackerValue: 'carHire',
    label: 'Car hire',
  },
];

export const DESKTOP_QUOTE_OPTIONS = [
  'recoveryLocal',
  'recoveryUk',
  'homeStart',
  'altTravel',
  'european',
];

export const COVER_TYPE_PREVALIDATION = COVER_LEVEL_OPTIONS.map(i => i.value);

export const PERSONAL_OR_VEHICLE_COVER_PREVALIDATION = [
  'personal',
  'vehicle',
];

export const VEHICLE_TYPES_PREVALIDATION = Object.keys(VEHICLE_TYPES);
